import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

export const appInsights = connectionString
  ? new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: false,
        disableFetchTracking: true,
        disableAjaxTracking: true,
      },
    })
  : null;

if (appInsights) {
  try {
    appInsights.loadAppInsights();
  } catch (error) {
    // Telemetry is non-critical and should not break the application.
    console.error("[Telemetry] Failed to initialize App Insights:", error);
  }
}
